import { defineMessages } from 'react-intl'

const messages = defineMessages({
  book: {
    id: 'global.book',
  },
  select: {
    id: 'global.select',
  },
  priceNight: {
    id: 'global.price-night',
  },
})

export default messages
